<template>
  <v-container id="project-overview" fluid tag="section">
    <v-row>
      <v-col cols="12" md="12">
        <idc-component-finance-wip :settings="settings" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'

  export default Vue.extend({
    name: 'DashboardFinanceWipSummary',
    components: {
      IdcComponentFinanceWip: () => import('@/components/idc/finances/Wip'),
    },
    computed: {
      ...mapState('Settings', ['settings']),
    },
  })
</script>

<style lang="sass">
  #project-overview
    .v-card
      margin: 0
    .col-12
      padding: 0.5em
</style>
